import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    position: 'relative',
  },
  image: {
    width: '100%',
    userSelect: 'none',
  },
  area: {
    position: 'absolute',
    cursor: 'pointer',

    '&:hover': {
      opacity: '0.6',
    },
  },
  selectedArea: {
    outline: '3px solid #000af6',
  },
  pulseAnimate: {
    animation: `$pulse 1000ms infinite ${theme.transitions.easing.easeInOut}`,
    transform: 'scale(1)',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.3)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
}));
